import React from 'react'
import MuiLink from '@material-ui/core/Link'
import { Link } from '@src/components/Link'
import { staticContent } from '@src/routes'
import { useUserSession } from '@utils/useUserSession'
import { FormattedMessage } from 'react-intl'
import messages from './messages'

export const UseFaqs = () => {
  const {
    userSession: { country, language },
  } = useUserSession()

  return {
    1: {},
    2: {},
    3: {},
    4: {
      messageValues: {
        b: (value) => <strong>{value}</strong>,
        linebreak: <br />,
        GS1Standard: (
          <MuiLink href="https://www.gs1.org/barcodes/2d">
            <FormattedMessage {...messages.GS1_STANDARD} />
          </MuiLink>
        ),
      },
    },
    5: {},
    6: {
      messageValues: {
        TheSmartLabelPage: (
          <Link
            {...staticContent.index({
              path: '/support/smart-label',
              language,
              country,
            })}
            passHref
          >
            <MuiLink target="_blank">
              <FormattedMessage {...messages.THE_SMART_LABEL_PAGE} />
            </MuiLink>
          </Link>
        ),
      },
    },
    7: {
      messageValues: {
        contactCustomerService: (
          <Link
            {...staticContent.index({
              path: '/support/customer-support',
              language,
              country,
            })}
            passHref
          >
            <MuiLink target="_blank">
              <FormattedMessage {...messages.CONTACT_CUSTOMER_SERVICE} />
            </MuiLink>
          </Link>
        ),
      },
    },
    8: {
      messageValues: {
        ScanNowAppDownloadPage: (
          <Link
            {...staticContent.index({
              path: '/support/smart-label/scan-now-app',
              language,
              country,
            })}
            passHref
          >
            <MuiLink target="_blank">
              <FormattedMessage {...messages.SCAN_NOW_APP_DOWNLOAD_PAGE} />
            </MuiLink>
          </Link>
        ),
      },
    },
    9: {
      answerSubsections: ['1', '2', '3', '4', '5', '6'],
      messageValues: {
        b: (value) => <strong>{value}</strong>,
        link: (
          <MuiLink href="https://www.gs1.org/about/what-we-do">
            <FormattedMessage {...messages.APPLICATION_IDENTIFIERS_ABOUT_GS1} />
          </MuiLink>
        ),
        gs1Website: (
          <MuiLink href="https://www.gs1.org/standards/barcodes/application-identifiers">
            <FormattedMessage {...messages.GS1_WEBSITE_HERE} />
          </MuiLink>
        ),
        gs1Standard: (
          <MuiLink href="https://www.gs1.org/standards/barcodes-epcrfid-id-keys/gs1-general-specifications">
            <FormattedMessage {...messages.GS1_STANDARD_HERE} />
          </MuiLink>
        ),
      },
    },
  }
}
